var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.599 6.5a3 3 0 0 0 .399-1.375"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.003 5.125A3 3 0 0 0 6.401 6.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.477 10.896a4 4 0 0 1 .585-.396"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 10.5a4 4 0 0 1 .585.396"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a4 4 0 0 1-1.967-.516"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.967 17.484A4 4 0 0 1 18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.2c6ec250f0efea62b723084f63ddd052.svg";
export { ForwardRef as ReactComponent };